// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class WorldExclamationMark extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // exclamationMark
    const exclamationMark = scene.add.image(0, 0, 'hud-icons', 240);
    this.add(exclamationMark);

    this.exclamationMark = exclamationMark;

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  private exclamationMark: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  initialize() {
    if (this.scene) {
      this.scene.tweens.add({
        targets: this.exclamationMark,
        duration: 2000,
        y: -4,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.inOut',
      });
      //new StaticSortByY(this.exclamationMark, 128);
      this.setDepth(999);
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
